import axios from 'axios';

const baseURL = import.meta.env.VITE_API_BASE_URL

console.log('✅ Using API base URL:', baseURL); // TEMP debug

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // ✅ Important if using cookies/sessions or secured endpoints
});

export const getApiBaseUrl = () => baseURL;

export default api;
